import { Button } from '@practium/ui';
import styles from './InstallmentCard.module.css';

interface InstallmentCardProps {
	onViewMore: () => void;
}

export const InstallmentCard = ({ onViewMore }: InstallmentCardProps) => {
	return (
		<div className={styles.card}>
			<div className={styles.blob1}>
				<svg
					width="171"
					height="100%"
					viewBox="0 0 171 140"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M171 -199.841C171 -2.39954 38.924 157.659 -124 157.659C-286.924 157.659 -419 -2.39954 -419 -199.841C-419 -397.283 -286.924 -557.341 -124 -557.341C38.924 -557.341 171 -397.283 171 -199.841Z"
						fill="#F84D7D"
					/>
				</svg>
			</div>
			<div className={styles.blob2}>
				{' '}
				<svg
					width="250"
					height="100%"
					viewBox="0 0 183 140"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<ellipse cx="146" cy="152" rx="146" ry="164" fill="#841EDE" />
				</svg>
			</div>
			<div className={styles.blob3}>
				<svg
					width="108"
					height="100%"
					viewBox="0 0 108 124"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<ellipse cx="146" cy="174.5" rx="146" ry="174.5" fill="#47BCBC" />
				</svg>
			</div>
			<div className={styles.content}>
				{' '}
				<h3 className={styles.title}>Parcelamentos</h3>
				<p className={styles.subtitle}>Crie modelos de parcelamentos personalizados</p>
			</div>
			<div className={styles.buttonWrapper}>
				<Button className={styles.button} onClick={onViewMore}>
					Ver Mais
				</Button>
			</div>
		</div>
	);
};
